<div class="dialog-content">
  <div class="content-wrapper">
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <h2 style="margin: 0;">Bulk Import</h2>
      <mat-icon class="cursor" mat-dialog-close>close</mat-icon>
    </div>
    <p style="margin-top: 16px;">If you want to bulk import into the system use this</p>
    <a
      [href]="csvTemplateUrl"
      target="_blank"
      class="download-template"
      >CSV Template</a
    >
    <app-uploader
      [hasError]="hasError"
      (onFileDropChange)="getPresignedUrl($event)"
    ></app-uploader>
  </div>
  <div class="action-button">
    <button
      type="button"
      [promiseBtn]="loading"
      [class.active]="fileUrl && !hasError"
      [disabled]="!fileUrl || hasError"
      class="primary-button custom-button"
      (click)="addCsv()"
    >
      Add CSV
    </button>
  </div>
</div>
